var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReceiptPage',{attrs:{"receipt-type":_vm.receiptType}})
}
var staticRenderFns = []

export { render, staticRenderFns }